if (!customElements.get("m-cart-addons")) {
  class MCartAddons extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        zipCode: '[name="address[zip]"]',
        province: '[name="address[province]"]',
        country: '[name="address[country]"]',
        addressForm: '[data-address="root"]',
        shippingMessage: ".m-cart-addon__shipping-rate",
        cartDiscountCode: '[name="discount"]',
        cartDiscountCodeNoti: "[data-discount-noti]",
        cartNote: '[name="note"]',
        saveAddonButton: ".m-cart-addon--save",
        closeAddonButton: ".m-cart-addon--close",
        calcShippingButton: ".m-cart-addon--calculate",
        triggerAddonButton: ".m-cart-addon--trigger-button",
        devliveryTime: '[name="attributes[Delivery time]"]',
      };
    }

    connectedCallback() {
      this.cartWrapper = document.querySelector(".m-cart-drawer");
      this.isCartPage = MinimogSettings.templateName === "cart";
      if (this.isCartPage) {
        this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
      }
      this.initAddress = false;
      this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay");
      this.domNodes = queryDomNodes(this.selectors, this);
      this.rootUrl = window.Shopify.routes.root;
      this.discountCodeKey = "minimog-discount-code";
      this.deliveryCodeKey = "minimog-delivery-code";
      this.init();
    }

    disconnectedCallback() {
      if (this._removeCloseAddonButton) this._removeCloseAddonButton();
      if (this._removeCalcShippingButton) this._removeCalcShippingButton();
    }

    init() {
      const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;
      addEventDelegate({
        selector: this.selectors.triggerAddonButton,
        context: this,
        handler: (e, addonButton) => {
          e.preventDefault();
          if (this.isCartPage) {
            const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
            if (addonCurrentActive) addonCurrentActive.classList.remove("open");
          }
          const { open: addonTarget } = addonButton.dataset;
          const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);
          this.removeActiveAllButton();
          addonButton.classList.add("active");
          addonNode && addonNode.classList.add("open");
          this.cartOverlay && this.cartOverlay.classList.add("open");
          this.openAddon = addonNode;

          if (addonTarget === "shipping") {
            fetchSection("country-options", { url: window.MinimogSettings.base_url })
              .then((html) => {
                const select = html.querySelector("#AddressCountry");
                const options = select && select.querySelectorAll("option");
                const defaultSelect = addonNode.querySelector("#MadrressCountry select");
                options &&
                  options.forEach((option) => {
                    defaultSelect && defaultSelect.appendChild(option);
                  });
                this.setupCountries();
                defaultSelect.value = defaultSelect && defaultSelect.dataset.default;
                this.applyDetectedCountry(defaultSelect);
              })
              .catch(console.error);
          }
        },
      });
      this._removeCloseAddonButton = addEventDelegate({
        selector: this.selectors.closeAddonButton,
        context: this.cartWrapper,
        handler: this.close.bind(this),
      });

      this._removeCalcShippingButton = addEventDelegate({
        selector: this.selectors.calcShippingButton,
        context: this.cartWrapper,
        handler: this.calcShipping.bind(this),
      });
      if (cartDiscountCode) {
        const code = localStorage.getItem(this.discountCodeKey);
        if (code) {
          cartDiscountCode.value = code;
          if (cartDiscountCodeNoti) {
            cartDiscountCodeNoti.style.display = "inline";
          }
        }
      }
      if (devliveryTime) {
        const code = localStorage.getItem(this.deliveryCodeKey);
        if (code) devliveryTime.value = code;
      }
      this.saveAddonValue();
      const today = new Date().toISOString().slice(0, 16);
      const deliveryTimeElm = this.querySelector("#delivery-time");
      if (deliveryTimeElm) deliveryTimeElm.min = today;
    }

    removeActiveAllButton() {
      const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
      triggerButtons && triggerButtons.forEach((button) => button.classList.remove("active"));
    }

    // Land van de bezoeker (door Shopify herkend op basis van de verbinding, geen GPS) als startwaarde,
    // alleen als we daarheen verzenden; anders blijft de standaard uit de thema-instelling staan
    applyDetectedCountry(select) {
      if (!select) return;
      const startValue = select.value;
      const shipCountries = (select.dataset.shipCountries || "").split(",").filter(Boolean);

      let request;
      try {
        const cached = sessionStorage.getItem("tcg-detected-country");
        if (cached) request = Promise.resolve(JSON.parse(cached));
      } catch (e) {}
      if (!request) {
        request = fetch("/browsing_context_suggestions.json?country[enabled]=true")
          .then((response) => response.json())
          .then((data) => {
            const country = (data && data.detected_values && data.detected_values.country) || null;
            try {
              sessionStorage.setItem("tcg-detected-country", JSON.stringify(country));
            } catch (e) {}
            return country;
          });
      }

      request
        .then((country) => {
          if (!country || !country.handle || select.value !== startValue) return;
          if (shipCountries.length && !shipCountries.includes(country.handle)) return;
          let englishName = "";
          try {
            englishName = new Intl.DisplayNames(["en"], { type: "region" }).of(country.handle);
          } catch (e) {}
          const option = Array.from(select.options).find(
            (opt) => opt.value === englishName || opt.textContent.trim() === country.name
          );
          if (!option || option.value === select.value) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change"));
        })
        .catch(() => {});
    }

    setupCountries() {
      if (this.initAddress) return;
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
          hideElement: "AddressProvinceContainer",
        });
        this.initAddress = true;
      }
    }

    close(event) {
      event.preventDefault();
      this.openAddon.classList.remove("open");
      this.cartOverlay && this.cartOverlay.classList.remove("open");
      this.removeActiveAllButton();
      this.openAddon = null;
    }

    calcShipping(event) {
      event.preventDefault();
      const actionsWrapper = event.target.closest(".m-cart-addon__action");
      actionsWrapper.classList.add("m-spinner-loading");
      const zipCode = (this.domNodes.zipCode && this.domNodes.zipCode.value && this.domNodes.zipCode.value.trim()) || "";
      const countryCode = this.countryCodeFor(this.domNodes.country);
      const message = this.domNodes.shippingMessage;
      const { shippingRatesResult, noShippingRate } = MinimogStrings;
      message.classList.remove("error");
      message.innerHTML = "";

      const showNoRates = () => {
        actionsWrapper.classList.remove("m-spinner-loading");
        message.innerHTML = `<p>${noShippingRate}</p>`;
      };
      if (!countryCode) {
        showNoRates();
        return;
      }

      this.fetchDeliveryOptions(countryCode, zipCode)
        .then((groups) => {
          const count = groups.reduce((total, options) => total + options.length, 0);
          if (!count) {
            showNoRates();
            return;
          }
          actionsWrapper.classList.remove("m-spinner-loading");
          const shippingLabel = document.createElement("P");
          shippingLabel.classList.add("m-cart-addon__shipping-rate--label");
          shippingLabel.textContent = `${shippingRatesResult.replace("{{count}}", count)}:`;
          message.appendChild(shippingLabel);
          const firstOption = groups.find((options) => options.length)[0];
          const formatter = new Intl.NumberFormat(document.documentElement.lang || "nl", {
            style: "currency",
            currency: firstOption.estimatedCost.currencyCode,
          });
          groups.forEach((options) => {
            options.forEach((option) => {
              const shippingRateItem = document.createElement("P");
              shippingRateItem.classList.add("m-cart-addon__shipping-rate--item");
              const price = document.createElement("span");
              price.textContent = formatter.format(Number(option.estimatedCost.amount));
              shippingRateItem.append(`${option.title}: `, price);
              message.appendChild(shippingRateItem);
            });
          });
        })
        .catch((error) => {
          console.error(error);
          showNoRates();
        });
    }

    // Landcode bij de gekozen landnaam; alleen landen waar we naartoe verzenden staan in de lijst
    countryCodeFor(select) {
      if (!select || !select.value) return "";
      const option = select.options[select.selectedIndex];
      let map = {};
      try {
        map = JSON.parse(select.dataset.shipCountryMap || "{}");
      } catch (e) {}
      const byName = option && map[option.textContent.trim()];
      if (byName) return byName;
      const shipCountries = (select.dataset.shipCountries || "").split(",").filter(Boolean);
      try {
        const names = new Intl.DisplayNames(["en"], { type: "region" });
        return shipCountries.find((code) => names.of(code) === select.value) || "";
      } catch (e) {
        return "";
      }
    }

    // Verzendtarieven via de Storefront API (zoals bij het afrekenen); cart/shipping_rates.json geeft
    // voor deze winkel geen tarieven terug. Er wordt een tijdelijke winkelwagen met dezelfde producten
    // aangemaakt; de echte winkelwagen blijft ongemoeid.
    fetchDeliveryOptions(countryCode, zip) {
      let token = "";
      try {
        token = JSON.parse(document.getElementById("shopify-features").textContent).accessToken;
      } catch (e) {}
      if (!token) return Promise.resolve([]);

      const query = `mutation EstimateShipping($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            deliveryGroups(first: 10) {
              nodes {
                deliveryOptions {
                  handle
                  title
                  deliveryMethodType
                  estimatedCost {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }`;

      return fetch(`${this.rootUrl}cart.js`)
        .then((response) => response.json())
        .then((cart) => {
          const lines = cart.items
            .filter((item) => item.requires_shipping)
            .map((item) => ({ merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`, quantity: item.quantity }));
          if (!lines.length) return [];
          const deliveryAddress = { countryCode };
          if (zip) deliveryAddress.zip = zip;
          return fetch("/api/2026-07/graphql.json", {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": token },
            body: JSON.stringify({
              query,
              variables: {
                input: {
                  lines,
                  // Land van de huidige winkelwagen (valuta zoals de bezoeker ziet); het afleveradres bepaalt het tarief
                  buyerIdentity: { countryCode: (window.Shopify && window.Shopify.country) || countryCode },
                  delivery: { addresses: [{ address: { deliveryAddress }, selected: true, oneTimeUse: true }] },
                },
              },
            }),
          })
            .then((response) => response.json())
            .then((result) => {
              const groups =
                (result &&
                  result.data &&
                  result.data.cartCreate &&
                  result.data.cartCreate.cart &&
                  result.data.cartCreate.cart.deliveryGroups.nodes) ||
                [];
              return groups.map((group) =>
                group.deliveryOptions.filter((option) => option.deliveryMethodType !== "PICK_UP")
              );
            });
        });
    }

    saveAddonValue() {
      addEventDelegate({
        event: "click",
        context: this.cartWrapper,
        selector: this.selectors.saveAddonButton,
        handler: (event, target) => {
          event.preventDefault();
          const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;
          if (target.dataset.action === "coupon" && cartDiscountCode) {
            const code = cartDiscountCode.value;
            localStorage.setItem(this.discountCodeKey, code);
            if (code !== "" && cartDiscountCodeNoti) {
              cartDiscountCodeNoti.style.display = "inline";
            } else {
              cartDiscountCodeNoti.style.display = "none";
            }
            this.close(event);
          }
          if (target.dataset.action === "note") {
            this.updateCartNote();
            this.close(event);
          }
          if (target.dataset.action === "delivery") {
            const code = devliveryTime.value;
            const isValidDate = Date.parse(code);
            if (isValidDate > Date.now()) {
              localStorage.setItem(this.deliveryCodeKey, code);
              this.close(event);
            } else {
              localStorage.setItem(this.deliveryCodeKey, "");
              devliveryTime.value = "";
              window.MinimogTheme.Notification.show({
                target: this.querySelector(".m-cart-addon-message-error"),
                method: "appendChild",
                type: "error",
                message: window.MinimogStrings.valideDateTimeDelivery,
                last: 3000,
                sticky: false,
              });
            }
          }
        },
      });
    }

    updateCartNote() {
      const cartNoteValue = this.domNodes.cartNote.value;
      const body = JSON.stringify({ note: cartNoteValue });
      fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }
  }
  customElements.define("m-cart-addons", MCartAddons);
}